import {FormGroup} from '@angular/forms';
import {RegistrationComponentFormData} from '../RegistrationComponentFormData';
import {RegistrationService} from '../registration.service';
import {RegistrationLearnerDataResponseDto} from '../../core/rest/api-types/RegistrationLearnerDataResponseDto';
import {RegistrationComponentFormDataValues} from '../RegistrationComponentFormDataValues';
import {RegistrationType} from '../registrationType';
import {RegistrationStrategy} from './RegistrationStrategy';
import {Result} from './Result';
import {BrandingService} from '../../../../../micromate-learn-lib/src/lib/services/branding/branding.service.js';

export class InvitationStrategy implements RegistrationStrategy {

    public type: RegistrationType = RegistrationType.Invitation;
    public shouldShowOrganisationInput: boolean = true;
    public shouldShowConfirmation: boolean = false;
    public titleTranslationKey: string = 'registration.flows.invitation.title';

    private userId!: string;

    constructor(private registrationService: RegistrationService,
                private brandingService: BrandingService) {
    }

    public enableForm(): void {
        // Nothing to enable here
    }

    public async initialize(formData: FormGroup<RegistrationComponentFormData>, userId: string): Promise<Result> {
        let registrationData: RegistrationLearnerDataResponseDto;
        try {
            registrationData = await this.registrationService.loadLearnerData(userId);
        } catch (e) {
            this.brandingService.setMicromateBranding();
            return new Result(false, 'registration.flows.invitation.alreadyInitializedTitle', 'registration.flows.invitation.alreadyInitialized');
        }
        this.brandingService.setBrandingManually(registrationData.organizationId);
        if (registrationData.alreadyInitialized) {
            return new Result(false, 'registration.flows.invitation.alreadyInitializedTitle', 'registration.flows.invitation.alreadyInitialized');
        } else {
            this.updateFormData(formData, registrationData);
            this.userId = userId;

            return new Result(true);
        }
    }

    private updateFormData(formData: FormGroup<RegistrationComponentFormData>, registrationCodeExchangeData: RegistrationLearnerDataResponseDto): void {
        formData.controls.email.setValue(registrationCodeExchangeData.email);
        formData.controls.organization.setValue(registrationCodeExchangeData.organizationName);
        formData.controls.email.disable();
        formData.controls.organization.disable();
    }

    public async execute(formData: RegistrationComponentFormDataValues): Promise<Result> {
        await this.registrationService.registerLearner(this.userId, formData);
        window.location.href = '/';
        return new Result(true);
    }
}

